import React , { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { cleanTitle } from '../../utils/helpers';
import { Helmet } from 'react-helmet';
import 'swiper/css'

const wpUrl = process.env.REACT_APP_WP_URL;
const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  slidesPerView: 1,
  loop: true,
  effect: 'fade',
  pagination: {
    el: '#main-slider-pagination',
    type: 'bullets',
    clickable: true
  },
  navigation: {
    nextEl: '#main-slider__swiper-button-next',
    prevEl: '#main-slider__swiper-button-prev'
  },
  autoplay: {
    delay: 8000
  }
}

export default function Banner() {
const [loading, setLoading] = useState(true);
   const [events, setEvents] = useState([]);
   useEffect(() => {
  fetch(`${wpUrl}wp-json/wp/v2/posts?status=publish&featured=1&_embed`)
    .then(res => res.json())
    .then(data => {
      const sortedEvents = data.sort((a, b) => {
        const dateA = new Date(a.event_date);
        const dateB = new Date(b.event_date);
        return dateB - dateA;
      });
      setEvents(sortedEvents);
      setLoading(false);
    })
    .catch(err => {
      console.error('Error fetching events:', err);
      setLoading(false);
    });
}, []);
    
   const firstImageUrl = events?.[0]?._embedded?.['wp:featuredmedia']?.[0]?.source_url;
  return (
    <>
     {firstImageUrl && (
        <Helmet>
          <link rel="preload" as="image" href={firstImageUrl} />
        </Helmet>
      )}
    {/* banner-one */}
    <section id='th-home' className="main-slider">
        {loading ? (
      <p>Loading banner...</p>
    ) : (
           <Swiper {...swiperOptions} className="swiper-container thm-swiper__slider">
            {events.map((event) => (
              <SwiperSlide className="swiper-slide" key={event.id}>
               <div className="main-slider__img">
                                   <img
                                     src={event._embedded?.['wp:featuredmedia']?.[0]?.source_url}
                                     alt={event.title.rendered}
                                     style={{ width: '100%', height: 'auto' }}
                                   />
                                 </div>
               
                                 <div className="container">
                                   <div className="row">
                                     <div className="col-xl-5">
                                       <div className="main-slider__content">
                                       
                                         <h2 className="main-slider__title">
                                             <Link to={`/event-details/${event.slug}`}>
                                            {cleanTitle(event.title.rendered)} 
                                            </Link>
                                         </h2>
                                        <ul className="list-unstyled main-slider__address">
                                         <li>
                                           <div className="icon">
                                             <span className="icon-pin"></span>
                                           </div>
                                           <div className="text">
                                             <p>{event.venue}</p>
                                           </div>
                                         </li>
                                         <li>
                                           <div className="icon">
                                             <span className="icon-clock"></span>
                                           </div>
                                           <div className="text">
                                             <p>{event.long_date}</p>
                                           </div>
                                         </li>
                                       </ul>
                                         <div className="main-slider__btn-box">
                                           <Link to="/contact" className="main-slider__btn thm-btn">
                                             Purchase Ticket
                                             <span className="icon-arrow-right"></span>
                                           </Link>
                                         </div>
                                       </div>
                                     </div>
                                   </div>
                                 </div>
              </SwiperSlide>
            ))}
          </Swiper>
          )}
          <div className="swiper-pagination" id="main-slider-pagination" />

        </section>
        {/* banner-one */}
    </>
    
  );
}
